import React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { Button } from '../components/Button';
import { PromptText } from '../components/PromptText';
import { ContentView } from '../components/ContentView';
import logo from '../assets/images/AbbisWayLogo.png';
import { LOGO_WIDTH, LOGO_HEIGHT } from '../components/consts';
export const WelcomeScreen = () => {
    const navigation = useNavigation();
    return (<ContentView edges={['top', 'bottom', 'left', 'right']} style={styles.container}>
      <View style={styles.container}>
        <Image source={logo} style={styles.logo}/>
        <PromptText prompt={"Welcome to Abbi's Way!"}/>
        <Text style={styles.welcome}>
          {"Abbi's Way is a companion to your coaching program.\n\nCreate your account to get started."}
        </Text>
        <View style={styles.button}>
          <Button title="Sign up" onPress={() => navigation.navigate('Signup')}/>
        </View>
      </View>
    </ContentView>);
};
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
    },
    welcome: {
        marginHorizontal: 50,
        marginTop: 100,
        fontSize: 20,
        marginBottom: 50,
        textAlign: 'center',
    },
    logo: {
        width: LOGO_WIDTH,
        height: LOGO_HEIGHT,
    },
    button: {
        width: 150,
        paddingVertical: 20,
    },
});
